// extracted by mini-css-extract-plugin
module.exports = {"errors":"Errors_errors__zs7Ds","text-error":"Errors_text-error__kHzKW","box":"Errors_box__cjvIb","fade-in":"Errors_fade-in__lAuo2"};